import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 20px;
`;

const PageHeader = styled.div`
  margin-bottom: 32px;
  
  h1 {
    font-size: 28px;
    margin-bottom: 8px;
  }
  
  p {
    color: ${props => props.theme.colors.textLight};
  }
`;

const ComingSoon = styled.div`
  background: ${props => props.theme.colors.surface};
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: 12px;
  padding: 48px;
  text-align: center;
  
  .icon {
    font-size: 64px;
    margin-bottom: 24px;
  }
  
  h2 {
    margin-bottom: 16px;
  }
  
  p {
    color: ${props => props.theme.colors.textLight};
    max-width: 400px;
    margin: 0 auto;
  }
`;

const Profile = () => {
  return (
    <Container>
      <PageHeader>
        <h1>Profile</h1>
        <p>Manage your health profile and preferences</p>
      </PageHeader>
      
      <ComingSoon>
        <div className="icon">👤</div>
        <h2>Coming Soon</h2>
        <p>
          Profile management interface is being built. This will include health goals, 
          preferences, food restrictions, and integration settings.
        </p>
      </ComingSoon>
    </Container>
  );
};

export default Profile;